var _dec, _class, _temp;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//@ts-nocheck

/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
import React from 'react';
import { StyleSheet, View } from 'react-native';
import { FalsyFC, TouchableWeb } from "../../devsupport";
import { Interaction, styled } from "../../theme";
import { Divider } from "../divider/divider.component";
export
/**
 * Cards contain content and actions about a single subject.
 *
 * @extends React.Component
 *
 * @property {ReactNode} children - Component to render within the card.
 *
 * @property {(ViewProps) => ReactElement} header - Function component
 * to render above the content.
 *
 * @property {(ViewProps) => ReactElement} footer - Function component
 * to render below the content.
 *
 * @property {(ViewProps) => ReactElement} accent - Function component
 * to render above the card.
 * Accents may change it's color depending on *status* property.
 *
 * @property {string} appearance - Appearance of the component.
 * Can be `filled` or `outline`.
 * Defaults to *outline*.
 *
 * @property {string} status - Status of the component.
 * Can be `basic`, `primary`, `success`, `info`, `warning`, `danger` or `control`.
 * Defaults to *basic*.
 *
 * @property {TouchableOpacityProps} ...TouchableOpacityProps - Any props applied to TouchableOpacity component.
 *
 * @overview-example CardSimpleUsage
 * In basic example, card accepts content view as child element.
 *
 * @overview-example CardAccessories
 * It also may have header and footer by configuring `header` and `footer` properties.
 *
 * @overview-example CardStatuses
 */
let Card = (_dec = styled('Card'), _dec(_class = (_temp = class Card extends React.Component {
  constructor(...args) {
    super(...args);

    _defineProperty(this, "onPressIn", event => {
      this.props.eva.dispatch([Interaction.ACTIVE]);
      this.props.onPressIn && this.props.onPressIn(event);
    });

    _defineProperty(this, "onPressOut", event => {
      this.props.eva.dispatch([]);
      this.props.onPressOut && this.props.onPressOut(event);
    });

    _defineProperty(this, "getComponentStyle", source => {
      const {
        bodyPaddingVertical,
        bodyPaddingHorizontal,
        accentHeight,
        accentBackgroundColor,
        headerPaddingVertical,
        headerPaddingHorizontal,
        footerPaddingVertical,
        footerPaddingHorizontal
      } = source,
            containerParameters = _objectWithoutProperties(source, ["bodyPaddingVertical", "bodyPaddingHorizontal", "accentHeight", "accentBackgroundColor", "headerPaddingVertical", "headerPaddingHorizontal", "footerPaddingVertical", "footerPaddingHorizontal"]);

      return {
        container: containerParameters,
        body: {
          paddingVertical: bodyPaddingVertical,
          paddingHorizontal: bodyPaddingHorizontal
        },
        accent: {
          height: accentHeight,
          backgroundColor: accentBackgroundColor
        },
        header: {
          paddingHorizontal: headerPaddingHorizontal,
          paddingVertical: headerPaddingVertical
        },
        footer: {
          paddingHorizontal: footerPaddingHorizontal,
          paddingVertical: footerPaddingVertical
        }
      };
    });

    _defineProperty(this, "renderStatusAccent", evaStyle => {
      return /*#__PURE__*/React.createElement(View, {
        style: evaStyle
      });
    });
  }

  render() {
    const _this$props = this.props,
          {
      eva,
      style,
      children,
      accent,
      header,
      footer
    } = _this$props,
          touchableProps = _objectWithoutProperties(_this$props, ["eva", "style", "children", "accent", "header", "footer"]);

    const evaStyle = this.getComponentStyle(eva.style);
    return /*#__PURE__*/React.createElement(TouchableWeb, _extends({}, touchableProps, {
      style: [styles.container, evaStyle.container, style],
      onPressIn: this.onPressIn,
      onPressOut: this.onPressOut
    }), /*#__PURE__*/React.createElement(FalsyFC, {
      style: evaStyle.accent,
      fallback: this.renderStatusAccent(evaStyle.accent),
      component: accent
    }), /*#__PURE__*/React.createElement(FalsyFC, {
      style: [styles.transparent, evaStyle.header],
      component: header
    }), header && /*#__PURE__*/React.createElement(Divider, null), /*#__PURE__*/React.createElement(View, {
      style: evaStyle.body
    }, children), footer && /*#__PURE__*/React.createElement(Divider, null), /*#__PURE__*/React.createElement(FalsyFC, {
      style: [styles.transparent, evaStyle.footer],
      component: footer
    }));
  }

}, _temp)) || _class);
const styles = StyleSheet.create({
  container: {
    overflow: 'hidden'
  },
  transparent: {
    backgroundColor: 'transparent'
  }
});